import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const resellerRoutesDictionary = moduleRouteDictionaryFactory(
  'reseller',
  'reseller',
  {
    listSplitFiles: 'list-split-files',
  },
);
